import React from "react";
import { Tooltip, Typography } from "@mui/material";
import CustomTableWithCollapse from "../../CustomTableWithCollapse";
import { Box, Avatar } from "@mui/material";
import { text } from "@fortawesome/fontawesome-svg-core";
import dayjs from "dayjs";
import CancelIcon from "@mui/icons-material/Cancel"; // Importamos el ícono alusivo
import { red } from "@mui/material/colors";

const PresupuestosTab = ({ rowsPadre, rowsHijo }) => {
  // Definir las columnas de padre e hijo
  const columnsPadre = [
    { field: "fecha_em_arg", headerName: "Fecha", width: "10%" },
    {
      field: "odontologo",
      headerName: "Odontólogo",
      textTransform: "capitalize",
      width: "25%",
    },
    {
      field: "prepaga_codigo",
      headerName: "Empresa",
      width: "5%",
    },
    {
      field: "bonificacion",
      headerName: "Bonif.",
      textTransform: "numeric",
      width: "5%",
    },
    {
      field: "importe_neto",
      headerName: "I.Neto",
      textTransform: "numeric",
      width: "10%",
    },
    {
      field: "pagado",
      headerName: "Pagado",
      textTransform: "numeric",
      width: "10%",
    },
    {
      field: "saldo",
      headerName: "Saldo",
      width: "10%",
      renderCell: (params) => {
        // Convertimos el valor de texto a número
        let value = parseFloat(params) || 0; // Si es NaN, lo asignamos como 0

        // Si el valor es 0 o null, no mostrar nada
        if (value === 0 || value === null) {
          return <div></div>; // Retorna un div vacío si es 0 o null
        }

        // Formateamos el valor con separador de miles y 2 decimales
        const formattedValue = value.toLocaleString("es-AR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        return (
          <div
            style={{
              textAlign: "right", // Alinea el texto a la derecha
              backgroundColor: "#f8d7da", // Rojo claro para el fondo
              color: "black", // Texto en negro
              padding: "8px", // Añadimos padding para mejorar la apariencia
              borderRadius: "6px", // Opcional: redondear las esquinas
              border: `1px solid ${red[500]}`, // Borde de color rojo 500
            }}
          >
            {formattedValue}
            {/* Mostramos el valor con separador de miles y 2 decimales */}
          </div>
        );
      },
    },
    {
      field: "saldo_anulado",
      headerName: "Anulado",
      width: "5%",
      renderCell: (params) => {
        // Si saldo_anulado es 1, mostramos el ícono, si es 0, mostramos nada
        console.log("Saldo anulado:", params); // Para depurar el valor
        if (params === undefined || params === null) {
          return null;
        }

        if (params === 1) {
          return (
            <Tooltip title="Saldo Anulado">
              <CancelIcon color="error" />
            </Tooltip>
          ); // Mostramos el ícono en rojo si está anulado
        }
        return null; // Si es 0, no mostramos nada
      },
    },
    {
      field: "observaciones",
      headerName: "Notas",
      width: "20%",
    },
  ];

  const columnsHijo = [
    { field: "codigo_nomenclador", headerName: "Código", width: "10%" },
    {
      field: "descripcion_nomenclador",
      headerName: "Descripción",
      textTransform: "capitalize",
      width: "300%",
    },
    {
      field: "numero_pieza_dental",
      headerName: "Pieza",
      width: "10%",
    },
    {
      field: "caras",
      headerName: "Caras",
      width: "10%",
    },
    {
      field: "importe",
      headerName: "Importe",
      textTransform: "numeric",
      width: "10%",
    },
  ];

  // Fecha actual
  const today = dayjs();

  // Fecha hace 3 años
  const threeYearsAgo = today.subtract(3, "year");
  // Antes de renderizar, modificamos el array rowsPadre
  const updatedRowsPadre = rowsPadre
    .map((row) => {
      // Convertir saldo a número y verificar si es menor a 100
      const saldo = parseFloat(row.saldo);
      if (saldo < 100) {
        row.saldo = "0"; // Si es menor a 100, lo ponemos en "0"
      }

      // Filtrar tratamientos cuya fecha_emision sea mayor a 3 años atrás
      const fechaEmision = dayjs(row.fecha_emision);
      if (fechaEmision.isBefore(threeYearsAgo)) {
        return null; // Si la fecha es antes de 3 años, la eliminamos (nulo)
      }

      return row;
    })
    .filter((row) => row !== null); // Filtra los valores nulos (tratamientos eliminados)
  // Calcular la sumatoria de saldos
  const totalSaldo = updatedRowsPadre
    .map((row) => parseFloat(row.saldo) || 0) // Convertimos saldo de string a número
    .reduce((acc, curr) => acc + curr, 0); // Sumamos todos los saldos
  // Formateamos el saldo total con separador de miles y dos decimales
  const formattedSaldo = totalSaldo.toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return (
    <div>
      <Typography
        variant="h7"
        sx={{
          fontWeight: "bold", // Negrita para resaltar
          fontSize: "1.2rem", // Tamaño de fuente más grande
          color: "#2C3E50", // Un color más oscuro para un mejor contraste
          borderBottom: "2px solid #3498db", // Línea debajo para un toque visual
          paddingBottom: "8px", // Espaciado inferior
          textAlign: "center", // Alineación centrada para mayor visibilidad
          textShadow: "1px 1px 3px rgba(0, 0, 0, 0.2)", // Sombra para darle profundidad
          marginBottom: "16px", // Espacio debajo
        }}
      >
        Saldo Total: {formattedSaldo}
      </Typography>

      <Box sx={{ mt: 2 }}>
        <CustomTableWithCollapse
          columnsPadre={columnsPadre}
          rowsPadre={updatedRowsPadre}
          columnsHijo={columnsHijo}
          rowsHijo={rowsHijo}
          filterFieldPadre="id"
          filterFieldHijo="presupuesto_id"
        />
      </Box>
    </div>
  );
};

export default PresupuestosTab;
